import { Stack, useText } from "@sveabank/cc-common";
import { Text } from "@sveabank/cc-common";
import type { DisplayedAddon } from "../../types/product";

type Props = {
	addon: DisplayedAddon;
};

const AddonItemPrice = ({ addon }: Props) => {
	const [t, texts] = useText();
	const isCheckCredit = addon.definitionId === "CHECKKREDIT";

	const monthlyFee = isCheckCredit
		? t(texts.chooseAddons.addonPrice, Number(addon.config.monthlyFees[0]?.fee.amount).toString())
		: t(texts.chooseAddons.addonPrice, Number(addon.config.monthlyFee.amount).toString());

	return (
		<div className="bg-background-brand-primary absolute top-[12%] left-0 z-10 flex h-20 w-20 items-center justify-center rounded-r-md">
			<Stack gap={0} align="center">
				{isCheckCredit && (
					<Text className="text-text-contrast self-center text-sm">{t(texts.common.from)}</Text>
				)}

				<Text
					bold
					className="text-text-contrast flex-1 text-2xl"
					data-testid={`addon-monthly-cost-${addon.definitionId}`}
				>
					{monthlyFee}
				</Text>

				<Text className="text-text-contrast self-center text-sm">
					{t(texts.chooseAddons.addonPriceBillingPeriod)}
				</Text>
			</Stack>
		</div>
	);
};

export default AddonItemPrice;
